import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const TimeInput = ({ questionnaireData }) => {
    const { questionNumber, value, defaultValue = {} } = questionnaireData;

    let hour = 0;
    let minute = 0;

    if (questionnaireData.answer) {
        const [h, m] = questionnaireData.answer.split(':');
        hour = parseInt(h);
        minute = parseInt(m);
    }

    const formattedTime = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

    return (
        <MainCard
            title={questionNumber ? `Questão ${questionNumber}` : null}
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                    {value}
                </Typography>
                <TextField
                    type="time"
                    value={formattedTime}
                    fullWidth
                    InputProps={{
                        readOnly: true
                    }}
                    inputProps={{
                        step: 60
                    }}
                />
            </Box>
        </MainCard>
    );
};

TimeInput.propTypes = {
    questionnaireData: PropTypes.shape({
        id: PropTypes.any.isRequired,
        questionNumber: PropTypes.number,
        value: PropTypes.string,
        defaultValue: PropTypes.shape({
            hour: PropTypes.number,
            minute: PropTypes.number
        })
    }).isRequired
};

export default TimeInput;
